import { ModuleContent } from '../contract';

/**
 * Content for the Text module.
 * Stores rich HTML text content.
 */
export type TextModuleContent = {
	text: string;
};

export function isTextModuleContent(content: ModuleContent): content is TextModuleContent {
	return typeof (content as TextModuleContent).text === 'string';
}

/**
 * Strips HTML tags and returns plain text for indexing.
 */
export function getTextModuleIndexableText(content: ModuleContent): string {
	if (!isTextModuleContent(content)) return '';
	return content.text.replace(/<[^>]*>/g, '').trim();
}
